// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AkVia","logo":"Navbar_logo__YJM-Q","icons":"Navbar_icons__LNu2m","searchWrapper":"Navbar_searchWrapper__ZKMBx","invisible":"Navbar_invisible__nFyc4"};